export default {
    formId: 'emisionForm',
    formField: {
        numeroReferencia: {
            name: 'numeroReferencia',
            label: 'Número de Referencia *',
            requiredErrorMsg: 'Debe indicar el número de referencia de la póliza emitida'
        },
        premium: {
            name: 'premium',
            label: 'Cuota Mensual *',
            requiredErrorMsg: 'Debe indicar la cuota mensual de la póliza emitida'
        },
        dni: {
            name: 'dni',
            label: 'DNI *',
            requiredErrorMsg: 'Debe especificar este campo'
        },
        cuit: {
            name: 'cuit',
            label: 'CUIT/CUIL *',
            requiredErrorMsg: 'Debe especificar el CUIT/CUIL'
        },
        fechaNacimiento: {
            name: 'fechaNacimiento',
            label: 'Fecha de nacimiento *',
            requiredErrorMsg: 'Debe especificar la fecha de nacimiento'
        },
        sexo: {
            name: 'sexo',
            label: 'Sexo *',
            requiredErrorMsg: 'Debe seleccionar un sexo'
        },
    }
};